import { IOccupancyStats, Kpi, KpiGrid } from '@localina/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStatsChange } from './RestaurantStatsChange';

interface IProps {
    stats: IOccupancyStats;
    previousWeekStats?: IOccupancyStats;
}

const getAvgPartySize = (stats: IOccupancyStats): number | undefined =>
    stats.numberOfReservations > 0 ? stats.numberOfGuests / stats.numberOfReservations : undefined;

const getPeakTime = (stats: IOccupancyStats): string | undefined =>
    stats.list.length === 0
        ? undefined
        : stats.list.reduce((max, it) => (it.occupancy > max.occupancy ? it : max), stats.list[0]).time;

// Guests and reservations sit beside the whole-day chart; this row keeps the derived figures.
export const RestaurantStatsKpiRow: React.FC<IProps> = (props) => {
    const { t } = useTranslation();
    const { changeHint, changeTone } = useStatsChange();

    const avgPartySize = getAvgPartySize(props.stats);
    const previousAvgPartySize = props.previousWeekStats ? getAvgPartySize(props.previousWeekStats) : undefined;

    return (
        <KpiGrid columns={2}>
            <Kpi
                label={t('dashboard.kpi.avgPartySize')}
                value={
                    avgPartySize?.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 }) ??
                    '—'
                }
                hint={changeHint(avgPartySize, previousAvgPartySize)}
                tone={changeTone(avgPartySize, previousAvgPartySize)}
            />
            <Kpi label={t('dashboard.kpi.peakTime')} value={getPeakTime(props.stats) ?? '—'} />
        </KpiGrid>
    );
};
